'use strict';

var _require = require('../constants'),
    LOCALHOST_MODE = _require.LOCALHOST_MODE,
    STANDALONE_MODE = _require.STANDALONE_MODE,
    PRODUCER_MODE = _require.PRODUCER_MODE,
    CONSUMER_MODE = _require.CONSUMER_MODE;

function mode(key, mode) {
  // Leaving the comparison as is, in case we change the mode name but not the setting.
  if (key === 'localhost') return LOCALHOST_MODE;

  if ([STANDALONE_MODE, PRODUCER_MODE, CONSUMER_MODE].indexOf(mode) === -1) throw Error('Invalid mode provided');

  return mode;
}

module.exports = mode;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/utils/settings/mode.js
// module id = 737
// module chunks = 10